
<style >
  .dropbox {
    outline: 2px dashed grey;
    outline-offset: -10px;
    background: white;
    color: dimgray;
    padding: 10px 10px;
    max-height: 3.5em;
    position: relative;

  }

  .input-file {
    opacity: 0;
    width: 100%;
    height: 4em;
    position: absolute;
  }

  .dropbox:hover {
    background: lightblue;
  }

  .dropbox p {
    text-align: center;
    padding: 0.5em 0;
  }

  .preview {
      max-height: 20em;
      width: 100% !important;
      vertical-align: middle !important;
  }

    .v-input.btnGrade.v-text-field {
        height: 4em;
    }

    .flex.xs3 {
        max-width: 20% !important;
    }

    .showTick{
        display: inline;
    }
    .hideTick{
        display: none;
    }

</style>
<template>
    <!-- <v-container> -->
        <v-card>
        <v-toolbar class="elevation1">
            <v-toolbar-title>Site settings</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-btn color="primary" v-if="isNotInPasswordsTab" centered @click.stop="saveActiveCardSettings()">SAVE</v-btn>
        </v-toolbar>
            <v-alert :value="true" type="success" dismissible v-model="success">
                Changes saved successfully
            </v-alert>
            <v-alert :value="true" type="error" dismissible v-model="error">
                There was an error with this action. Please try again.
            </v-alert>
            <v-alert :value="true" type="info" dismissible v-model="pendingChanges">
                There are pending changes. Remember to save them before leaving so you don't lose them.
            </v-alert>
            <v-tabs
                v-model="active"
                color="green lighten6"
                dark
                slider-color="primary"
                >
                    <v-tab ripple @click="success=false; isNotInPasswordsTab=true"> Login Page  
                        <v-icon color="blue" v-bind:class="{'showTick': this.pendingChanges1, 'hideTick': !this.pendingChanges1}">
                            info_outline
                        </v-icon>
                    </v-tab>
                    <v-tab-item>
                        <v-card flat>
                            <v-card>
                                <v-card-text>
                                    <v-layout row wrap>
                                        <v-text-field label="Welcome Message" v-model="welcomeMessage" @change="showPendingChangesAlert(1)"></v-text-field>
                                    </v-layout>
                                </v-card-text>
                            </v-card>
                            <v-card>
                                <v-card-text>Background Image</v-card-text>
                                <v-container>
                                    <div class="dropbox">
                                        <input type="file" style="opacity: 0!important" multiple :name="uploadFieldNameBack"  label="Background Image"
                                        @change="backgroundImageChange($event.target.name, $event.target.files);
                                        fileCount = $event.target.files.length" accept="image/*" class="input-file">
                                        <p v-if="isBgInitial">Drag your file here to begin  or click to browse</p>
                                        <p v-if="isBgSaving">Uploading files...</p>
                                        <p v-if="isBgSaved">New background image saved.</p>
                                    </div>
                                    <div class="preview">
                                        <img :src="backgroundImage" style="max-height: 200px; vertical-align: bottom; margin: 4px" />
                                        <v-btn v-if="bgImageControl" color="default" @click.stop="deleteBackgroundImg()">remove</v-btn>
                                    </div>
                                </v-container>
                            </v-card>
                            <v-card>
                                <v-card-text>
                                    Additional Logo
                                </v-card-text>
                                <v-container>
                                    <div class="dropbox">
                                        <input type="file" style="opacity: 0 !important" multiple :name="uploadFieldNameLogo"  label="Additional Logo"
                                        @change="logoImageChanged($event.target.name, $event.target.files);
                                        fileCount = $event.target.files.length" accept="image/*" class="input-file">
                                        <p v-if="isLogoInitial">Drag your file here to begin or click to browse</p>
                                        <p v-if="isLogoSaving">Uploading files...</p>
                                        <p v-if="isLogoSaved">New additional logo image saved.</p>
                                    </div>
                                    <div>
                                        <img :src="additionalLogo" style="max-height: 200px; vertical-align: bottom; margin: 4px" />
                                        <v-btn v-if="addLogoControl" color="default" @click.stop="removeAdditionalLogo()">remove</v-btn>
                                    </div>
                                </v-container>
                            </v-card>
                        </v-card>
                    </v-tab-item>
                    <v-tab ripple @click="success=false; isNotInPasswordsTab=true"> Effort Rubric  
                        <v-icon color="blue" v-bind:class="{'showTick': this.pendingChanges2, 'hideTick': !this.pendingChanges2}">
                            info_outline
                        </v-icon>
                    </v-tab>
                    <v-tab-item>
                        <v-card flat>
                            <v-card-text>
                                <v-switch label="Show teacher's name on Student Efforts screen"
                                v-model="switchTeacherName" color="primary" @change="showOrHide()"
                                ></v-switch>
                            </v-card-text>
                        </v-card>
                        <v-card>
                            <v-container fluid grid-list-md>
                                    <v-layout row wrap v-for="card in cards" :key="card.title">
                                        <v-flex xs12>
                                            <h3>{{ card.title }}</h3>
                                            <br>
                                        </v-flex>
                                        <v-flex v-for="setting in card.settings" :key="setting.id" xs3>
                                            <v-text-field
                                                class="btnGrade"
                                                box
                                                label="Text"
                                                v-bind:value="setting.button.text"
                                                v-bind:ref="setting.button.text"
                                                @change="saveSetting(setting.button.key, $event); showPendingChangesAlert(2)"
                                                
                                            ></v-text-field>
                                            <v-textarea
                                                height="10em"
                                                box
                                                label="Description"
                                                v-bind:value="setting.description.text"
                                                v-bind:ref="setting.description.text"
                                                @change="saveSetting(setting.description.key, $event); showPendingChangesAlert(2)"
                                            ></v-textarea>
                                        </v-flex>
                                    </v-layout>
                                    <br>
                            </v-container>
                        </v-card>
                    </v-tab-item>
                    <v-tab ripple @click="success=false; isNotInPasswordsTab=true"> Effort Criteria  
                        <v-icon color="blue" v-bind:class="{'showTick': this.pendingChanges3, 'hideTick': !this.pendingChanges3}">
                            info_outline
                        </v-icon>
                    </v-tab>
                    <v-tab-item>
                        <v-card flat>
                            <v-card-text>
                                <h3>Criteria 1</h3>
                                <v-text-field
                                    v-model="diligenceLabel"
                                    counter="15"
                                    maxlength="15"
                                    @change="showPendingChangesAlert(3)"
                                    ></v-text-field>
                                <v-layout row wrap>
                                    <v-text-field
                                    v-model="diligenceSTD"
                                    label="Students Description"
                                    @change="showPendingChangesAlert(3)"
                                    ></v-text-field>
                                </v-layout>
                                <v-layout row wrap>
                                    <v-text-field
                                    v-model="diligenceTTD"
                                    label="Teachers Description"
                                    @change="showPendingChangesAlert(3)"
                                    ></v-text-field>
                                </v-layout>
                            </v-card-text>
                            <v-card-text>
                                <h3>Criteria 2</h3>
                                <v-text-field
                                    v-model="engagementLabel"
                                    counter="15"
                                    maxlength="15"
                                    @change="showPendingChangesAlert(3)"
                                    ></v-text-field>
                                <v-layout row wrap>
                                    <v-text-field
                                    v-model="engagementSTD"
                                    label="Students Description"
                                    @change="showPendingChangesAlert(3)"
                                    ></v-text-field>
                                </v-layout>
                                <v-layout row wrap>
                                    <v-text-field
                                    v-model="engagementTTD"
                                    label="Teachers Description"
                                    @change="showPendingChangesAlert(3)"
                                    ></v-text-field>
                                </v-layout>
                            </v-card-text>
                            <v-card-text>
                                <h3>Criteria 3</h3>
                                <v-text-field
                                    v-model="behaviourLabel"
                                    counter="15"
                                    maxlength="15"
                                    @change="showPendingChangesAlert(3)"
                                    ></v-text-field>
                                <v-layout row wrap>
                                    <v-text-field
                                    v-model="behaviourSTD"
                                    label="Students Description"
                                    @change="showPendingChangesAlert(3)"
                                    ></v-text-field>
                                </v-layout>
                                <v-layout row wrap>
                                    <v-text-field
                                    v-model="behaviourTTD"
                                    label="Teachers Description"
                                    @change="showPendingChangesAlert(3)"
                                    ></v-text-field>
                                </v-layout>
                            </v-card-text>
                        </v-card>
                    </v-tab-item>
                    <!-- <v-tab ripple> Widgets </v-tab> -->
                    <!-- <v-tab-item>
                        <v-card flat>
                            <v-card-text>
                                <v-layout row wrap>
                                    <v-text-field label="Contact form widget ID" 
                                    v-model="widgetId" 
                                    :rules="[rules.numeric]"
                                    :required ="false"
                                    ></v-text-field>
                                    <v-btn :disabled="btnsavewidgetId" color="primary" @click.stop="saveWidgetId()" >SAVE</v-btn>
                                </v-layout>
                            </v-card-text>
                        </v-card>
                    </v-tab-item> -->
                    <v-tab ripple @click="success=false; isNotInPasswordsTab=true"> Middle Manager Actions </v-tab>
                    <v-tab-item>
                        <v-card flat>
                            <v-card-text>
                                <v-switch label="Delete Class"
                                v-model="deleteClass" color="primary" @change="changeSettingDeleteClass()"
                                ></v-switch>
                           
                                <v-switch label="Show or Hide Class"
                                v-model="hideClass" color="primary" @change="changeSettingHideClass()"
                                ></v-switch>

                                <v-switch label="Manage Class Students"
                                v-model="inspectStudents" color="primary" @change="changeSettingInspectStudents()"
                                ></v-switch>
                         
                                <v-switch label="Manage Class Teachers"
                                v-model="manageTeachers" color="primary" @change="changeSettingManageTeachers()"
                                ></v-switch>
                            </v-card-text>
                        </v-card>
                    </v-tab-item>
                     <v-tab ripple @click="success=false; isNotInPasswordsTab=false"> Users Passwords 
                        <v-icon color="blue" v-bind:class="{'showTick': this.pendingChanges4, 'hideTick': !this.pendingChanges4}">
                            info_outline
                        </v-icon>
                     </v-tab>
                    <v-tab-item>
                        <v-card flat>
                            <v-container>
                                <v-card-text>
                                    <v-layout row wrap>
                                        <v-flex xs4>
                                            <v-text-field
                                                :append-icon="studentsDefaultPasswordMask ? 'visibility' : 'visibility_off'"
                                                @click:append="() => (studentsDefaultPasswordMask = !studentsDefaultPasswordMask)"
                                                :type="studentsDefaultPasswordMask ? 'password' : 'text'"
                                                label="Student Default Password"
                                                hint="At least 6 characters"
                                                min="8"
                                                v-model="studentsDefaultPassword" 
                                                @change="showPendingChangesAlert(4)"
                                            >
                                                <v-tooltip slot="append-outer" right> 
                                                        <v-icon slot="activator" @click="generatePassword('Student')">password</v-icon>
                                                        <span>suggest strong password</span>
                                                </v-tooltip>
                                            </v-text-field>
                                            
                                            <v-btn color="primary" @click.stop="loadDefaultConfirmationDialog('Student')">Save</v-btn>
                                            <v-btn color="error" @click.stop="loadResetConfirmationDialog('Student')">Reset All Student Passwords</v-btn>
                                        </v-flex>
                                         <v-progress-linear indeterminate :active="loadingStudents"></v-progress-linear>
                                    </v-layout>
                                </v-card-text>
                            </v-container>
                            <v-container>
                                <v-card-text>
                                    <v-layout row wrap>
                                        <v-flex xs4>
                                            <v-text-field
                                                :append-icon="teachersDefaultPasswordMask ? 'visibility' : 'visibility_off'"
                                                @click:append="() => (teachersDefaultPasswordMask = !teachersDefaultPasswordMask)"
                                                :type="teachersDefaultPasswordMask ? 'password' : 'text'"
                                                label="Teacher Default Password"
                                                hint="At least 6 characters"
                                                min="8"
                                                v-model="teachersDefaultPassword" 
                                                @change="showPendingChangesAlert(4)"
                                                
                                            >
                                                <v-tooltip slot="append-outer" right> 
                                                        <v-icon slot="activator" @click="generatePassword('Teacher')">password</v-icon>
                                                    <span>suggest strong password</span>
                                                </v-tooltip>
                                            </v-text-field>
                                            <v-btn color="primary" @click.stop="loadDefaultConfirmationDialog('Teacher')">Save</v-btn>
                                            <v-btn color="error" @click.stop="loadResetConfirmationDialog('Teacher')">Reset All Teacher Passwords</v-btn>
                                        </v-flex>
                                        <v-progress-linear indeterminate :active="loadingTeachers"></v-progress-linear>
                                    </v-layout>
                                </v-card-text>
                            </v-container>
                        </v-card>
                    </v-tab-item>
            </v-tabs>
            <v-dialog v-model="dialog" persistent max-width="340">
                <v-card>
                    <v-card-title class="text-h5">
                        Leave without saving?
                    </v-card-title>
                    <v-card-text>There are pending changes to save. If you leave without saving them, they will be lost.</v-card-text>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn color="primary" text @click="okPendingChanges(true)">OK</v-btn>
                        <v-btn color="primary" text @click="okPendingChanges(false)">Go Back to Save Changes</v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>
            <v-dialog v-model="dialog2" persistent max-width="340">
                <v-card>
                    <v-card-title class="text-h5">
                        There are Pending Changes
                    </v-card-title>
                    <v-card-text>If you change the period without saving them, they will be lost.</v-card-text>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn color="primary" text @click="okPendingChanges2()">OK</v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>
            <v-dialog v-model="dialog3" max-width="35%">
                <v-card>
                    <v-card-title>
                        Confirmation
                    </v-card-title>
                    <v-card-text>
                            <v-layout row wrap>
                                    This action will &nbsp; <span style="color: #b71c1c !important;"><b> RESET </b></span> &nbsp; all {{ resetOption }} passwords to Default. 
                            </v-layout>
                    </v-card-text>
                        <v-card-text>
                            <v-layout row wrap>
                                <i>Note: Please be patient, it can take a while.</i>
                            </v-layout>
                        </v-card-text>
                    <v-card-actions>
                        <v-btn color="primary" flat @click.stop="unloadResetConfirmationDialog()">Cancel</v-btn>
                        <v-spacer></v-spacer>
                        <v-btn color="error" outlined @click.stop="resetPasswords('')">Confirm</v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>
            <v-dialog v-model="dialog4" max-width="35%">
                <v-card>
                    <v-card-title>
                        Confirmation
                    </v-card-title>
                    <v-card-text>
                            <v-layout row wrap>
                                    This action will &nbsp; <span style="color: #b71c1c !important;"><b> CHANGE </b></span> &nbsp; the {{ defaultOption }} default password. 
                            </v-layout>
                            <v-layout row wrap>
                                    <v-switch v-model="execResetDefaultPassword" color="primary" label="Change the default password of those who have not changed it yet (Please be patient, it can take a while)"></v-switch>
                            </v-layout>
                    </v-card-text>
                    <v-card-actions>
                        <v-btn color="primary" flat @click.stop="unloadDefaultConfirmationDialog()">Cancel</v-btn>
                        <v-spacer></v-spacer>
                        <v-btn color="error" outlined @click.stop="saveDefaultPasswords(defaultOption)">Confirm</v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>
        </v-card>
    <!-- </v-container> -->
</template>
<script>

    import { initialize, showHideTeacherName, getShowingTeacherName, saveSettings} from '../utils/effort-tracking-api'
    import { saveSettingAsImage, saveSettingAsText, getSetting, getSettings, getBackgroundImg, removeBackgroundImg } from '../utils/effort-tracking-api'
    import { deleteSetting, saveGradingTabsSettings, getTabsSettings, getGradingButtonsSettings } from '../utils/effort-tracking-api'
    import { postMiddleManagerSettings, getMiddleManagersSettings, resetUsersPasswordToDefault, getImageBySettingsKey, removeImageBySettingsKey } from '../utils/effort-tracking-api'

    import axios from 'axios'
    import { faLastfmSquare } from '@fortawesome/free-brands-svg-icons'

    export default {
        name: 'Settings',
        data() {
            return {
                switchTeacherName: false,
                selectedPeriodId: localStorage.getItem('period-selected'),
                uploadFieldNameBack: 'BackgroundImage',
                uploadFieldNameLogo: 'AdditionalLogo',
                welcomeMessage: '',
                isBgInitial: true,
                isBgSaving: false,
                isBgSaved: false,
                isLogoInitial: true,
                isLogoSaving: false,
                isLogoSaved: false,
                active: null,
                backgroundImage: '',
                additionalLogo: '',
                bgImageId: 0,
                addLogoId: 0,
                bgImageControl: false,
                addLogoControl: false,
                success: false,
                error: false,
                pendingChanges: false,
                pendingChanges1: false,
                pendingChanges2: false,
                pendingChanges3: false,
                pendingChanges4: false,
                isNotInPasswordsTab: true,
                diligenceLabel: '',
                diligenceSTD: '',
                diligenceTTD: '',
                engagementLabel: '',
                engagementSTD: '',
                engagementTTD: '',
                behaviourLabel: '',
                behaviourSTD: '',
                behaviourTTD: '',
                diligenceButtons: [],
                diligenceDescriptions: [],
                engagementButtons: [],
                engagementDescriptions: [],
                behaviourButtons: [],
                behaviourDescriptions: [],
                savedSettings: [],
                defaultCards: [],
                defaultButtons: [],
                widgetId: '',
                rules: {
                    numeric: value => {
                        const pattern = /^(\s*|\d+)$/
                        return pattern.test(value) || 'Please enter a numeric value.'
                    }
                },
                btnsavewidgetId: true,
                cards: [
                    { title: 'Diligence', flex: 12,
                        buttons:  [
                            {id: '0', text: '1 - UNSATISFACTORY', key: 'd-grade-button-text-1'},
                            {id: '1', text: '2 - FAIR', key: 'd-grade-button-text-2'},
                            {id: '2', text: '3 - GOOD', key: 'd-grade-button-text-3'},
                            {id: '4', text: '4 - VERY GOOD', key: 'd-grade-button-text-4'},
                            {id: '5', text: '5 - OUTSTANDING', key: 'd-grade-button-text-5'}
                        ],
                        descriptions: [
                            {id: '6', text: '', key: 'd-grade-button-description-1'},
                            {id: '7', text: '', key: 'd-grade-button-description-2'},
                            {id: '8', text: '', key: 'd-grade-button-description-3'},
                            {id: '9', text: '', key: 'd-grade-button-description-4'},
                            {id: '10', text: '', key: 'd-grade-button-description-5'}
                        ]
                    },
                    { title: 'Engagement', flex: 12,
                        buttons: [
                            {id: '11', text: '1 - UNSATISFACTORY', key: 'e-grade-button-text-1'},
                            {id: '12', text: '2 - FAIR', key: 'e-grade-button-text-2'},
                            {id: '13', text: '3 - GOOD', key: 'e-grade-button-text-3'},
                            {id: '14', text: '4 - VERY GOOD', key: 'e-grade-button-text-4'},
                            {id: '15', text: '5 - OUTSTANDING', key: 'e-grade-button-text-5'}
                        ],
                        descriptions: [
                            {id: '16', text: '', key: 'e-grade-button-description-1'},
                            {id: '17', text: '', key: 'e-grade-button-description-2'},
                            {id: '18', text: '', key: 'e-grade-button-description-3'},
                            {id: '19', text: '', key: 'e-grade-button-description-4'},
                            {id: '20', text: '', key: 'e-grade-button-description-5'}
                        ]
                    },
                    { title: 'Behaviour', flex: 12,
                        buttons: [
                            {id: '21', text: '1 - UNSATISFACTORY', key: 'b-grade-button-text-1'},
                            {id: '22', text: '2 - FAIR', key: 'b-grade-button-text-2'},
                            {id: '23', text: '3 - GOOD', key: 'b-grade-button-text-3'},
                            {id: '24', text: '4 - VERY GOOD', key: 'b-grade-button-text-4'},
                            {id: '25', text: '5 - OUTSTANDING', key: 'b-grade-button-text-5'}
                        ],
                        descriptions:[
                            {id: '26', text: '', key: 'b-grade-button-description-1'},
                            {id: '27', text: '', key: 'b-grade-button-description-2'},
                            {id: '28', text: '', key: 'b-grade-button-description-3'},
                            {id: '29', text: '', key: 'b-grade-button-description-4'},
                            {id: '30', text: '', key: 'b-grade-button-description-5'}
                        ]
                    }
                ],
                deleteClass: false,
                hideClass: false,
                inspectStudents: false,
                manageTeachers: false,
                middleManagerSettings: [],
                dialog: false,
                toRedirect: 'null',
                dialog2: false,
                noRememberDialog2: false,
                cachePeriods: [],
                cacheToken: '',
                cacheUsertype: '',
                cacheUserdata: null,
                dialog3: false,
                resetOption: '',
                dialog4: false,
                defaultOption: '',
                studentsDefaultPassword: '',
                teachersDefaultPassword: '',
                loadingTeachers: false,
                loadingStudents: false,
                studentsDefaultPasswordMask: true,
                teachersDefaultPasswordMask: true,
                settings: {
                    maxLength: 64,
                    maxDigits: 10,
                    maxSymbols: 10,
                    length: 12,
                    digits: 4,
                    symbols: 2,
                    ambiguous: true,
                },
                firstWelcomeMsg: '',
                execResetDefaultPassword: false
            }
        },
        watch: {
            backgroundImage(val) {
                this.bgImageControl = (val != '') ? true : false
            },
            additionalLogo(val) {
                this.addLogoControl = (val != '') ? true : false
            },
            bgImageId(val) {
                this.bgImageId = val;
            },
            widgetId(value) {
                var errors = document.getElementsByClassName('v-messages error--text');
                this.btnsavewidgetId = errors.length > 0;
            },
            pendingChanges(value)
            {
                this.noRememberDialog2 = false;
            },
            diligenceLabel(val)
            {
                this.cards[0].title = this.diligenceLabel;
            },
            engagementLabel(val)
            {
                this.cards[1].title = this.engagementLabel;
            },
            behaviourLabel(val)
            {
                this.cards[2].title = this.behaviourLabel;
            }
        },
        methods: {
            backgroundImageChange(name, files) {
                this.isBgInitial = false;
                this.isBgSaving = true;
                let formData = new FormData();
                formData.append('settingsKey', 'background-image-URL');
                formData.append('settingsValue', files[0]);
                saveSettingAsImage(formData).then(result => {
                    console.log(result);
                    this.isBgSaving = false;
                    this.isBgSaved = true;
                    getBackgroundImg().then(result => {
                        console.log(result);
                        this.backgroundImage = (result.fileContents !== undefined ) ? 'data:' + result.contentType + ';base64,' + result.fileContents : '';
                        setTimeout(() => { this.isBgSaved = false; this.isBgInitial = true }, 5000);
                    }).catch(ex => console.log(ex));
                }).catch(ex => console.log(ex));
            },
            logoImageChanged(name, files){
                this.isLogoInitial = false;
                this.isBgSaving = true;
                let formData = new FormData();
                formData.append('settingsKey', 'additional-logo');
                formData.append('settingsValue', files[0]);
                saveSettingAsImage(formData).then(result => {
                    console.log(result);
                    this.isLogoSaving = false;
                    this.isLogoSaved = true;

                    getImageBySettingsKey('additional-logo').then(result => {
                        console.log(result);
                        this.additionalLogo = (result.fileContents !== undefined ) ? 'data:' + result.contentType + ';base64,' + result.fileContents : '';
                        setTimeout(() => { this.isLogoSaved = false; this.isLogoInitial = true }, 5000);
                    }).catch(ex => console.log(ex));

                    // getSetting('additional-logo').then(setting => {
                    //     this.additionalLogo = (setting.value !== undefined ) ? setting.value : '';
                    //     this.addLogoId = (setting.id !== undefined ) ? setting.id : 0;
                    //     setTimeout(() => { this.isLogoSaved = false; this.isLogoInitial = true }, 5000);
                    // }).catch(ex => console.log(ex));
                }).catch(ex => console.log(ex));
            },
            saveActiveCardSettings() {

                console.log (this.active);

                switch (this.active){
                    case 0: 
                        this.saveWelcomeMessage();
                        break;
                    case 1: 
                        this.saveAllSettings();
                        break;
                    case 2: 
                        this.saveTabsSettings();
                        break;
                }
            },
            showPendingChangesAlert(option){
                switch (option){
                    case 1: 
                        if (this.firstWelcomeMsg != this.welcomeMessage)
                            this.pendingChanges1 = true;
                        break;
                    case 2: 
                        this.pendingChanges2 = true;
                        break;
                    case 3: 
                        this.pendingChanges3 = true;
                        break;
                    case 4: 
                        this.pendingChanges4 = true;
                        break;
                }

                if (this.pendingChanges1 || this.pendingChanges2 || this.pendingChanges3 || this.pendingChanges4)
                    this.pendingChanges = true;
                    
            },
            hidePendingChangesAlert(){
                if (!this.pendingChanges1 && !this.pendingChanges2 && !this.pendingChanges3 && !this.pendingChanges4)
                    this.pendingChanges = false;
            },
            saveWelcomeMessage() {
                let formData = new FormData();
                formData.append('settingsKey', 'welcome-text');
                formData.append('settingsValue', this.welcomeMessage);
                saveSettingAsText(formData).then(result => {
                    this.success = true;
                    this.pendingChanges1 = false;
                    this.hidePendingChangesAlert();
                    console.log(result);
                }).catch(ex => {
                    console.log(ex)
                    this.error = true;
                });
            },
            saveWidgetId() {
                let formData = new FormData();
                formData.append('settingsKey', 'widget-id');
                formData.append('settingsValue', this.widgetId);
                saveSettingAsText(formData).then(result => {
                    this.success = true;
                    localStorage.setItem('widget-id', this.widgetId);
                }).catch(ex => { 
                    console.log(ex)
                    this.error = true;
                });
            },
            saveSetting(key, model) {
                var buttonsText = [];

                this.defaultCards.forEach(element => {
                    element.buttons.forEach(eb => {
                        this.defaultButtons.push(eb);
                    });
                });
                var defaultSetting = this.defaultButtons.filter(df => df.key == key);
                if(model == '' && key.indexOf('text') != -1)
                    model = defaultSetting[0].text;

                this.savedSettings.push(key + ':' + model);
            },
            saveAllSettings(){
                var rows = this.generateRows(this.savedSettings);
                var g_jsonSettings = JSON.stringify(rows);
                var g_settings = JSON.stringify({
                    Settings: g_jsonSettings
                });

                saveSettings(g_settings).then(result => {
                    if(result.status == 200)
                    {
                        this.success = true;
                        this.pendingChanges2 = false;
                        this.hidePendingChangesAlert();
                    } else {
                        this.error = true
                    }
                }).catch( ex => {
                    console.log(ex);
                    this.error = true;
                });

            },
            saveDefaultSettings() {
                var innerSettings = [];
                this.success = false;
                this.hidePendingChangesAlert();
                this.error = false;
                this.cards.forEach(card => {
                    card.buttons.forEach(btn => {
                        innerSettings.push(btn.key + ':' + btn.text);
                    });
                    card.descriptions.forEach(desc => {
                        innerSettings.push(desc.key + ':' + desc.text);
                    });
                });

                var rows = this.generateRows(innerSettings);
                var g_jsonSettings = JSON.stringify(rows);
                var g_settings = JSON.stringify({
                    Settings: g_jsonSettings
                });

                saveSettings(g_settings).then(result => {
                    this.getEffortCriteriaSettings();
                }).catch( ex => {
                    console.log(ex);
                    this.error = true;
                });
            },
            generateRows(columnsResult)
            {
                var jsonData = {};
                columnsResult.forEach(function(column)
                {
                    var data = column.split(':');
                    jsonData[data[0]] = data[1];
                });
                return jsonData;
            },
            saveTabsSettings() {
                this.success = false;
                this.error = false;
                var settings = {
                    'diligence-label': this.diligenceLabel,
                    'diligence-student': this.diligenceSTD,
                    'diligence-teacher': this.diligenceTTD,
                    'engagement-label': this.engagementLabel,
                    'engagement-student': this.engagementSTD,
                    'engagement-teacher': this.engagementTTD,
                    'behaviour-label': this.behaviourLabel,
                    'behaviour-student': this.behaviourSTD,
                    'behaviour-teacher': this.behaviourTTD
                };

                var jsonSetings = JSON.stringify(settings);
                var _settings = JSON.stringify({
                    Settings: jsonSetings
                });

                saveGradingTabsSettings(_settings).then(result => {
                    console.log(result);
                    if(result.status == 200) {
                        this.success = true;
                        this.pendingChanges3 = false;
                        this.hidePendingChangesAlert();
                    } else {
                        this.error = true;
                    }
                }).catch(ex => {
                    console.log(ex);
                    this.error = true;
                });
            },
            unloadDefaultConfirmationDialog() {
                this.dialog4 = false;
                this.defaultOption = '';
                this.execResetDefaultPassword = false;
            },
            loadDefaultConfirmationDialog(option) {
                this.dialog4 = true;
                this.defaultOption = option;
            },
            saveDefaultPasswords(option) {
                this.success = false;
                this.error = false;
                var changeDefaultPasswords = this.execResetDefaultPassword;
                var prevDefaultPassword = '';
                var settings = {};

                if (option == 'Student')
                    settings = {'students-default-password': this.studentsDefaultPassword};

                if (option == 'Teacher')
                    settings = {'teachers-default-password': this.teachersDefaultPassword};
                
                var jsonSetings = JSON.stringify(settings);
                var _settings = JSON.stringify({
                    Settings: jsonSetings
                });

                if (changeDefaultPasswords)
                {
                    if (option == 'Student')
                    {
                        getSetting('students-default-password').then(setting => {
                            prevDefaultPassword = (setting.value !== undefined ) ? setting.value : 'effort23';
                        }).catch(ex => console.log(ex));
                    }

                    if (option == 'Teacher')
                    {
                        getSetting('teachers-default-password').then(setting => {
                            prevDefaultPassword = (setting.value !== undefined ) ? setting.value : 'bZ7a!B9jq';
                        }).catch(ex => console.log(ex));
                    }
                }

                saveSettings(_settings).then(result => {
                    this.success = true;
                    this.pendingChanges4 = false;
                    this.hidePendingChangesAlert();
                    this.unloadDefaultConfirmationDialog();
                    console.log(result);

                    if (changeDefaultPasswords)
                    {
                        this.resetOption = option;
                        this.resetPasswords(prevDefaultPassword);
                    }

                }).catch( ex => {
                    console.log(ex);
                    this.error = true;
                    this.unloadDefaultConfirmationDialog();
                });
            },
            showOrHide() {
                showHideTeacherName(this.switchTeacherName).then(result => {
                    console.log("Show teacher's name on Student Efforts screen: " + this.switchTeacherName);
                    console.log(result);
                }).catch(ex => console.log(ex));
            },
            deleteBackgroundImg(){
                removeBackgroundImg().then(result => {
                                console.log(result);
                                this.backgroundImage = '';
                                this.bgImageId = 0
                }).catch(ex => console.log(ex));
            },
            removeAdditionalLogo() {
                removeImageBySettingsKey('additional-logo').then(result => {
                            console.log(result);
                            this.additionalLogo = '';
                            localStorage.setItem('additional-logo', '');
                            this.addLogoId = 0;
                }).catch(ex => console.log(ex));
            },
            // removeSetting(id, type) {
            //     deleteSetting(id).then(result => {
            //         console.log(result);
            //         if(result.status == 200) {
            //             if (type == 'logo')
            //             {
            //                 this.additionalLogo = '';
            //                 localStorage.setItem('additional-logo', '');
            //                 this.addLogoId = 0;
            //             }
                            
            //             if (type == 'background')
            //             {
            //                 this.backgroundImage = '';
            //                 localStorage.setItem('background-image', '');
            //                 this.bgImageId = 0
            //             }
                            
            //         }
            //     }).catch(ex => console.log(ex));
            // },
            getEffortCriteriaSettings(){
                getGradingButtonsSettings().then(settingsCards => {
                    if(settingsCards.diligenceTexts.length == 0)
                    {
                        this.saveDefaultSettings();
                    } 
                    else 
                    {
                        this.cards = [];
                    }

                    var _cards = this.cards.map(cc => cc.title);

                    // Card Diligence
                    if(settingsCards.diligenceTexts.length > 0) {
                        var index = _cards.indexOf('Diligence');
                        this.diligenceButtons = [];
                        this.diligenceDescriptions = [];
                        settingsCards.diligenceTexts.forEach(element => {
                            var button = {
                                id: element.id,
                                text: element.value,
                                key: element.key
                            };
                            this.diligenceButtons.push(button);
                        });

                        settingsCards.diligenceDescriptions.forEach(element => {
                            var description = {
                                id: element.id,
                                text: element.value,
                                key: element.key
                            };
                            this.diligenceDescriptions.push(description);
                        });

                        var dSettings = [];
                        this.diligenceButtons.forEach((element, index) => {
                            dSettings.push({
                                id: 'ds_' + index,
                                button: element,
                                description: this.diligenceDescriptions[index]
                            });
                        });

                        var diligenceCard =  { title: this.diligenceLabel, flex: 12,
                            settings: dSettings
                        };

                        this.cards.push(diligenceCard);
                    }

                    // Card Engagement
                    if(settingsCards.engagementTexts.length > 0) {
                        var index = _cards.indexOf('Engagement');
                        this.engagementeButtons = [];
                        this.engagementDescriptions = [];
                        settingsCards.engagementTexts.forEach(element => {
                            var button = {
                                id: element.id,
                                text: element.value,
                                key: element.key
                            };
                            this.engagementeButtons.push(button);
                        });

                        settingsCards.engagementDescriptions.forEach(element => {
                            var description = {
                                id: element.id,
                                text: element.value,
                                key: element.key
                            };
                            this.engagementDescriptions.push(description);
                        });

                        var eSettings = [];
                        this.engagementeButtons.forEach((element, index) => {
                            eSettings.push({
                                id: 'es_' + index,
                                button: element,
                                description: this.engagementDescriptions[index]
                            });
                        });

                        var engagementCard =  { title: this.engagementLabel, flex: 12,
                            settings: eSettings
                        };

                        this.cards.push(engagementCard);
                    }

                    // Card behaviour
                    if(settingsCards.behaviourTexts.length > 0) {
                        var index = _cards.indexOf('Engagement');
                        this.behaviourButtons = [];
                        this.behaviourDescriptions = [];
                        settingsCards.behaviourTexts.forEach(element => {
                            var button = {
                                id: element.id,
                                text: element.value,
                                key: element.key
                            };
                            this.behaviourButtons.push(button);
                        });

                        settingsCards.behaviourDescriptions.forEach(element => {
                            var description = {
                                id: element.id,
                                text: element.value,
                                key: element.key
                            };
                            this.behaviourDescriptions.push(description);
                        });

                        var bSettings = [];
                        this.behaviourButtons.forEach((element, index) => {
                            bSettings.push({
                                id: 'es_' + index,
                                button: element,
                                description: this.behaviourDescriptions[index]
                            });
                        });

                        var behaviourCard =  { title: this.behaviourLabel, flex: 12,
                            settings: bSettings
                        };

                        this.cards.push(behaviourCard);
                    }
                }).catch(ex => console.log(ex));
            },
            changeSettingDeleteClass()
            {
                console.log('DELETE class setting changing...');
                console.log(this.deleteClass);
                var key = 'middle-manager-delete-class';
                postMiddleManagerSettings(key, this.deleteClass).then(result => {
                    console.log(result);
                }).then(result => {
                    getSetting('middle-manager-delete-class').then(setting => {
                        console.log ('CHANGED CLASS ST: ');
                        console.log(setting);
                        // this.backgroundImage = (setting.value !== undefined ) ? setting.value : '';
                        // this.bgImageId = (setting.id !== undefined ) ? setting.id : 0;
                        // setTimeout(() => { this.isBgSaved = false; this.isBgInitial = true }, 5000);
                    }).catch(ex => console.log(ex));
                });
            },
            changeSettingHideClass()
            {
                console.log('HIDE class setting changing...');
                console.log(this.hideClass);
                var key = 'middle-manager-hide-class';
                postMiddleManagerSettings(key, this.hideClass).then(result => {
                    console.log(result);
                });
            },
            changeSettingInspectStudents()
            {
                console.log('INSPECT STUDENTS setting changing...');
                console.log(this.inspectStudents);
                var key = 'middle-manager-inspect-students';
                postMiddleManagerSettings(key, this.inspectStudents).then(result => {
                    console.log(result);
                });
            },
            changeSettingManageTeachers()
            {
                console.log('MANAGE TEACHERS setting changing...');
                console.log(this.manageTeachers);
                var key = 'middle-manager-manage-teachers';
                postMiddleManagerSettings(key, this.manageTeachers).then(result => {
                    console.log(result);
                });
            },
            preventNav(event) {
                if (!this.pendingChanges) return
                event.preventDefault()
                event.returnValue = ""
            },
            preventPeriodSelection(event) {
                if (event.target.className.startsWith('v-select__selections') && !this.noRememberDialog2)
                {
                    if (!this.pendingChanges) 
                        return;
                    this.dialog2 = true;
                    event.preventDefault()
                    event.returnValue = ""
                }
            },
            okPendingChanges(answer)
            {
                this.dialog = false;

                if (!answer)
                {
                    if (this.$store.state.userdata == null)
                    {
                        this.cachePeriods.forEach(p => {this.$store.state.periods.push(p)});
                        this.$store.state.token = this.cacheToken;
                        this.$store.state.usertype = this.cacheUsertype;
                        this.$store.state.userdata = this.cacheUserdata;
                    }
                    return;
                }
                else
                {
                    this.pendingChanges = false;
                    this.$router.push({ name: this.toRedirect.name});
                }
            },
            okPendingChanges2()
            {
                this.dialog2 = false;
                this.noRememberDialog2 = true;
                return;
            },
            unloadResetConfirmationDialog() {
                this.dialog3 = false;
                this.resetOption = '';
            },
            loadResetConfirmationDialog(option) {
                this.dialog3 = true;
                this.resetOption = option;
            },
            resetPasswords(prevDefaultPassword) {
                this.dialog3 = false;

                switch(this.resetOption)
                {
                    case 'Student': 
                        this.loadingStudents = true;
                        break;
                    case 'Teacher': 
                        this.loadingTeachers = true;
                        break;
                }

                var tmpResetOption = this.resetOption;

                resetUsersPasswordToDefault(tmpResetOption,{prevDefaultPassword: prevDefaultPassword}).then(result => {
                switch(tmpResetOption)
                {
                    case 'Student': 
                        this.loadingStudents = false;
                        break;
                    case 'Teacher': 
                        this.loadingTeachers = false;
                        break;
                }

                this.resetOption = '';

                if(result.status == 200) {
                    console.log(result.data);
                    this.success = true;
                } else {
                    console.log(result.response.data);
                    this.error = true;
                }
                });
            },
            // generate the password
            generatePassword(option) {
                var lettersSetArray = ["a", "b", "c", "d", "e", "f", "g", "h", "i", "j", "k", "l", "m", "n", "o", "p", "q", "r", "s", "t", "u", "v", "w", "x", "y", "z"];
                var symbolsSetArray = [ "=","+","-","^","?","!","%","&","*","$","#","^","@","|"];
                //var ambiguousSetArray = ["(",")","{","}","[","]","(",")","/","~",";",":",".","<",">"];
                var passwordArray = [];
                var digitsArray = [];
                var digitsPositionArray = [];


                // first, fill the password array with letters, uppercase and lowecase
                for (var i = 0; i < this.settings.length; i++) {
                    // get an array for all indexes of the password array
                    digitsPositionArray.push(i);

                    var upperCase = Math.round(Math.random() * 1);
                    if (upperCase === 0) {
                    passwordArray[i] = lettersSetArray[Math.floor(Math.random()*lettersSetArray.length)].toUpperCase();
                    }
                    else {
                    passwordArray[i] = lettersSetArray[Math.floor(Math.random()*lettersSetArray.length)];
                    }
                }

                // Add digits to password
                for (i = 0; i < this.settings.digits; i++) {
                    var digit = Math.round(Math.random() * 9);
                    var numberIndex = digitsPositionArray[Math.floor(Math.random()*digitsPositionArray.length)];

                    passwordArray[numberIndex] =  digit;

                    /* remove position from digitsPositionArray so we make sure to the have the exact number of digits in our password
                    since without this step, numbers may override other numbers */

                    var j = digitsPositionArray.indexOf(numberIndex);
                    if(i != -1) {
                    digitsPositionArray.splice(j, 1);
                    }
                }

                // add special charachters "symbols"
                for (i = 0; i < this.settings.symbols; i++) {
                    var symbol = symbolsSetArray[Math.floor(Math.random()*symbolsSetArray.length)];
                    var symbolIndex = digitsPositionArray[Math.floor(Math.random()*digitsPositionArray.length)];

                    passwordArray[symbolIndex] =  symbol;

                    /* remove position from digitsPositionArray so we make sure to the have the exact number of digits in our password
                    since without this step, numbers may override other numbers */

                    var j = digitsPositionArray.indexOf(symbolIndex);
                    if(i != -1) {
                    digitsPositionArray.splice(j, 1);
                    }
                }

                if (option == "Student")
                {
                    this.studentsDefaultPassword = passwordArray.join("");
                    this.studentsDefaultPasswordMask = false;
                }
                else
                {
                    this.teachersDefaultPassword = passwordArray.join("");
                    this.teachersDefaultPasswordMask = false;
                }

                this.showPendingChangesAlert(4);
            }
        },
        mounted() {
            initialize().then(x => {
                this.defaultCards = this.cards;
                
                getSetting('welcome-text').then(setting => {
                    this.welcomeMessage = (setting.value !== undefined ) ? setting.value : '';
                    this.firstWelcomeMsg = this.welcomeMessage;
                }).catch(ex => console.log(ex));

                getTabsSettings().then(tabs => {
                    var diligence = tabs.filter(tb => tb.name == 'DILIGENCE')[0];
                    this.diligenceLabel = (diligence.customName !== '' ) ? diligence.customName : diligence.name;
                    this.diligenceSTD = diligence.studentDescription;
                    this.diligenceTTD = diligence.teacherDescription;

                    var engagement = tabs.filter(tb => tb.name == "ENGAGEMENT")[0];
                    this.engagementLabel = (engagement.customName !== '' ) ? engagement.customName : engagement.name;
                    this.engagementSTD = engagement.studentDescription;
                    this.engagementTTD = engagement.teacherDescription;

                    var behaviour = tabs.filter(tb => tb.name == "BEHAVIOUR")[0];
                    this.behaviourLabel = (behaviour.customName !== '' ) ? behaviour.customName : behaviour.name;
                    this.behaviourSTD = behaviour.studentDescription;
                    this.behaviourTTD = behaviour.teacherDescription;

                }).catch(ex => console.log(ex));

                getSetting('widget-id').then(setting2 => {
                    this.widgetId = (setting2.value !== undefined ) ? setting2.value : '';
                }).catch(ex => console.log(ex));

                getMiddleManagersSettings().then(settings => {
                    if(settings.length > 0)
                    {
                        this.middleManagerSettings = settings;
                        var _deleteClass = settings.filter(st => st.key == 'middle-manager-delete-class');
                        // console.log('DELETE CLASS ??');
                        if(_deleteClass.length > 0)
                            this.deleteClass = _deleteClass[0].value == 'true';
                        
                        // console.log(this.deleteClass);

                        var _hideClass = settings.filter(st => st.key == 'middle-manager-hide-class');
                        // console.log('HIDE CLASS ??');
                        if(_hideClass.length > 0)
                            this.hideClass = _hideClass[0].value == 'true';
                        
                        // console.log(this.hideClass);

                        var _inspectStudents = settings.filter(st => st.key == 'middle-manager-inspect-students');
                        // console.log('INSPECT STUDENTS ??');
                        if(_inspectStudents.length > 0)
                            this.inspectStudents = _inspectStudents[0].value == 'true';
                        
                        // console.log(this.inspectStudents);

                        var _manageTeachers = settings.filter(st => st.key == 'middle-manager-manage-teachers');
                        // console.log('MANAGE TEACHERS ??');
                        if(_manageTeachers.length > 0)
                            this.manageTeachers = _manageTeachers[0].value == 'true';
                        
                        // console.log(this.manageTeachers);
                    }
                }).catch(ex => console.log(ex));

                getSetting('students-default-password').then(setting3 => {
                    this.studentsDefaultPassword = (setting3.value !== undefined ) ? setting3.value : 'effort23';
                }).catch(ex => console.log(ex));

                getSetting('teachers-default-password').then(setting4 => {
                    this.teachersDefaultPassword = (setting4.value !== undefined ) ? setting4.value : 'bZ7a!B9jq';
                }).catch(ex => console.log(ex));

                // getSetting('additional-logo').then(setting5 => {
                //     this.additionalLogo = (setting5.value !== undefined ) ? setting5.value : '';
                //     this.addLogoId = (setting5.id !== undefined ) ? setting5.id : 0;
                // }).catch(ex => console.log(ex));

                getImageBySettingsKey('additional-logo').then(result => {
                    console.log('Additional logo img result: ');
                    console.log(result);

                    this.additionalLogo = (result.fileContents !== undefined ) ? 'data:' + result.contentType + ';base64,' + result.fileContents : '';
                }).catch(ex => console.log(ex));

                getBackgroundImg().then(result => {
                    this.backgroundImage = (result.fileContents !== undefined ) ? 'data:' + result.contentType + ';base64,' + result.fileContents : '';
                }).catch(ex => console.log(ex));

                getShowingTeacherName().then(result => {
                    console.log('Get showing teacher name...');
                    console.log(result);

                    this.switchTeacherName = result;
                    this.getEffortCriteriaSettings();
                }).catch(ex => console.log(ex));
                
            });
        },
                
        beforeMount() {
            window.addEventListener("beforeunload", this.preventNav)
            this.$once("hook:beforeDestroy", () => {
            window.removeEventListener("beforeunload", this.preventNav);
            });
            window.addEventListener("click", this.preventPeriodSelection)
            this.$once("hook:beforeDestroy", () => {
            window.removeEventListener("click", this.preventPeriodSelection);
            });

            //get State Information
            this.$store.state.periods.forEach(p => {this.cachePeriods.push(p)});
            this.cacheToken = this.$store.state.token;
            this.cacheUsertype = this.$store.state.usertype;
            this.cacheUserdata = this.$store.state.userdata;
        },

        beforeRouteLeave(to, from, next) {
            if (this.pendingChanges) {
                this.dialog = true;
                this.toRedirect = to;
            }
            else
                next();
        },
    }
</script>


// WEBPACK FOOTER //
// src/components/Settings.vue